module.exports = __webpack_public_path__ + "img/logo_footer.0690ce36.svg";